var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('img',{staticStyle:{"object-fit":"fill","height":"100vh","width":"100vh","display":"flex"},attrs:{"src":require("@/assets/404.png")}})])
}]

export { render, staticRenderFns }